import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20digital%20media%20abstract%20background%20with%20flowing%20gradient%20waves%2C%20warm%20orange%20and%20deep%20crimson%20tones%20blending%20with%20dark%20background%2C%20cinematic%20light%20streaks%2C%20technological%20yet%20artistic%20atmosphere%2C%20minimalist%20composition%2C%204k%20quality%2C%20no%20text&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="国产视频大全 - 正版高清在线观看"
          title="国产视频大全 - 国产视频精选平台"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
          发现精彩<span className="text-accent-400">国产视频</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed">
          汇聚海量正版高清国产视频资源，涵盖影视剧、综艺、纪录片、短视频等多元内容，每日更新，免费畅享优质国产原创内容
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <Link
            to="/category/yingshiju"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full text-sm md:text-base transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-fill mr-2"></i>开始浏览
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 bg-white/10 hover:bg-white/20 text-white backdrop-blur-sm font-medium rounded-full text-sm md:text-base transition-all duration-300 border border-white/20 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line mr-2"></i>了解更多
          </Link>
        </div>

        <div className="grid grid-cols-3 gap-4 md:gap-8 mt-12 md:mt-16 max-w-lg mx-auto">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white font-heading">50万+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">视频资源</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">5000万+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">注册用户</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white font-heading">每日更新</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">持续上新</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}